<template>
  <BaseModal col-md="col-md-6" offset="3"
             :subtitulo="tabSelect === 'info' ? 'Informações de serviços' : 'Editar serviço'"
             :modalColor="tabSelect === 'info' ? 'border-primary bg-success' : 'border-warning bg-warning'">
    <template v-slot:modalContent>
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li v-if="tabSelect === 'info'">
            <a class="nav-link" :class="tabSelect === 'info' ? 'active' : ''" data-toggle="tab" href="#tab-1"
            >Informações</a>
          </li>
          <li v-if="tabSelect === 'info'">
            <a class="nav-link" data-toggle="tab" href="#tab-2"
            >Documentos</a>
          </li>
          <li v-if="tabSelect === 'info'">
            <a class="nav-link" data-toggle="tab" href="#tab-3"
            >Imagens</a>
          </li>
          <li v-if="tabSelect === 'edit'">
            <a class="nav-link" :class="tabSelect === 'edit' ? 'active' : ''" data-toggle="tab" href="#tab-4"
            >Editar serviço</a>
          </li>
        </ul>
        <div class="tab-content">
          <div v-if="tabSelect === 'info'" id="tab-1" class="tab-pane" :class="tabSelect === 'info' ? 'active' : ''">
            <div class="panel-body">
              <InformacoesServico
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
          <div v-if="tabSelect === 'info'" id="tab-2" class="tab-pane">
            <div class="panel-body">
              <DocumentosServicos
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
          <div v-if="tabSelect === 'info'" id="tab-3" class="tab-pane">
            <div class="panel-body">
              <ImagensServicos
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>

          <div v-if="tabSelect === 'edit'" id="tab-4" class="tab-pane" :class="tabSelect === 'edit' ? 'active' : ''">
            <div class="panel-body">
              <EditarServico
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
                  @atualizarDados="$emit('atualizarDados', $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import InformacoesServico from "@/views/servicos/InformacoesServico.vue";
import EditarServico from "@/views/servicos/EditarServico.vue";
import ImagensServicos from "@/views/servicos/ImagensServicos.vue";
import DocumentosServicos from "@/views/servicos/DocumentosServicos.vue";

export default {
  name: "TabsModalAnalise",
  components: {
    BaseModal,
    InformacoesServico,
    EditarServico,
    ImagensServicos,
    DocumentosServicos,
  },
  props: {
    itemKey: String,
    tabSelect: String,
  },
  emits: ['fechar', 'atualizarDados'],
};
</script>
